export default __webpack_public_path__ + "static/media/blog-2.24fa6565.jpg";